import { CurrencyCodes } from '../enums/currencies.enum';

const CURRENCY_SYMBOLS: Record<string, string> = {
  [CurrencyCodes.usd]: '$',
  [CurrencyCodes.irr]: 'T',
};

export const currencyToSymbol = (currency?: string | null): string => {
  if (!currency) {
    return '';
  }

  return CURRENCY_SYMBOLS[currency.toLowerCase()] ?? '';
};
